import { addons } from "@storybook/manager-api";
import supamenuTheme from "./SupamenuTheme";

addons.setConfig({
  theme: supamenuTheme,
});
